/*
 * @Author: zjw
 * @Date: 2021-05-17 17:07:36
 * @LastEditTime: 2021-07-16 16:42:13
 * @FilePath: \web-app\src\network\request.js
 * @Environment: Vue + Element
 * @Description: api请求
 */
import axios from 'axios'
import router from '../router'
import {
    Message
} from 'element-ui'

const noTokenList = ['/sso/app/login'] //免token接口列表

export function request(config) {
    //创建实例
    const instace = axios.create({
        //判断开发环境还是生产环境，api代替的是target中的接口地址
        baseURL: process.env.NODE_ENV == 'development' ? '/api' : '/api',
        timeout: 60*1000
    })

    /**
     * @param {*} retry  请求重试的次数
     * @param {*} retryDelay  请求重试延迟时间
     */
    instace.defaults.retry = 3;
    instace.defaults.retryDelay = 2000;

    // 实例请求拦截器
    instace.interceptors.request.use(config => {
        let token = localStorage.getItem('token')

        //判断是否有token，有token的话header头携带
        if (!noTokenList.includes(config.url) && token) {
            config.headers['Authorization'] = 'Bearer ' + token // 每个请求携带自定义token
        }

        return config
    }, err => {
        return Promise.reject(error);
    })
    // 实例响应拦截器(根据服务器的响应code码进行一些操作)
    instace.interceptors.response.use(response => {
        if (response.status != 200) {
            Message({
                message: 'Error',
                type: 'error',
                duration: 5 * 1000
            })
            return response;
        } else {
            //跳转404页面
            // if (response.data.code == 1) {
            //     Message({
            //         message: response.data.msg,
            //         type: 'error',
            //         duration: 5 * 1000
            //     })
            //     // router.push({
            //     //     path: "/404"
            //     // })
            // }
            // 拦截器实现axios请求重试
            // let config = response.config;
            // if(!config || !config.retry) return Promise.reject(response);
            // // 在请求对象上设置重试次数
            // config.__retryCount = config.__retryCount || 0;
            // // 判断是否超过了重试次数
            // if(config.__retryCount >= config.retry) {
            //     // Reject with the error
            //     return Promise.reject(err);
            // }
            // // 增加重试次数
            // config.__retryCount += 1;
            // // 延时处理
            // var backoff = new Promise(function(resolve) {
            //     setTimeout(function() {
            //         resolve();
            //     }, config.retryDelay || 1);
            // });

            // // 重新发起请求
            // return backoff.then(function() {
            //     return axios(config);
            // });
			if(response.data.code==200){
				return response;
			}else if(response.data.code==100){ //登陆过期
				Message({
					message: '登陆已过期，请重新登陆',
					type: 'error',
					duration: 5 * 1000
				})
				localStorage.clear();
				router.push({
				    path: "/login"
				})
			}else{
				Message({
					message: response.data.msg,
					type: 'error',
					duration: 5 * 1000
				})
				return response;
			}
            
        }

    }, error => {
        if (error.response.status) {
            switch (error.response.status) {
                // 401: 未登录
                // 404: 接口报错
                // 未登录则跳转登录页面，并携带当前页面的路径
                // 在登录成功后返回当前页面，这一步需要在登录页操作。
                case 500:
                    Message({
                        message: error.response.statusText,
                        type: 'error',
                        duration: 5 * 1000
                    })
                    break
                    // 其他错误，直接抛出错误提示
                default:
                    Message({
                        message: error.response.data.error,
                        type: 'error',
                        duration: 5 * 1000
                    })
            }
            return Promise.reject(error.response)
        }
    });

    //发送网络请求，网络请求返回的参数通过函数再回调回去
    return instace(config)
}